<app-header
  [applicationsTotal]="applicationsTotal$ | async"
  [bookmarksTotal]="(bookmarkMap$ | async)?.size"
  [profile]="profile$ | async"
  [isLogged]="isLogged$ | async"
></app-header>

<app-header-banner class="directory-companies-banner">
  <div class="container">
    <h1 class="directory-companies-header__title">
      <span class="highlight" i18n>Annuaires</span>
    </h1>
  </div>
</app-header-banner>

<main class="container">
  <app-tab-bar class="directory-companies-tabs">
    <app-link [path]="jobsUrl" i18n-label label="Jobs" [exact]="true"></app-link>

    <app-link [path]="companiesUrl" i18n-label label="Entreprises" [exact]="true"></app-link>

    <app-link [path]="domainsJobsUrl" i18n-label label="Emplois par domaine"></app-link>

    <app-link [path]="jobsCitiesUrl" i18n-label label="Emplois par ville"></app-link>

    <app-link [path]="jobsContractsUrl" i18n-label label="Emplois par contrat"></app-link>
  </app-tab-bar>

  <router-outlet></router-outlet>
</main>

<app-footer [isLogged]="isLogged$ | async"></app-footer>
